var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:_vm.s.aboutCentent},[(_vm.navs)?_c('div',{class:_vm.s.nav},[_c('div',{class:_vm.s.navBar},_vm._l((_vm.navs),function(item,index){return _c('div',{key:item.nav,class:[
        _vm.s.navSingle,
        { [_vm.s.heighLight]: index === _vm.navIndex },
      ],on:{"click":function($event){return _vm.changeNav(index)}}},[_vm._v(" "+_vm._s(item.nav)+" ")])}),0)]):_vm._e(),(_vm.item)?_c('div',{class:[_vm.s.textBox, {
    [_vm.s.publicity]: _vm.key === 'publicity',
    [_vm.s.textBoxWithNav]: !!_vm.navs
  }]},[_c('h3',{domProps:{"innerHTML":_vm._s(_vm.item.title)}}),(_vm.key === 'publicity')?_c('Publicity'):(_vm.key === 'licenses')?_c('Licenses'):(_vm.key === 'public-info')?_c('PublicInfo'):_c('Introduce')],1):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }